// Front/src/hooks/useLogin.js

import { useState } from "react";
import { useAuthContext } from "./useAuthContext";
import { useTranslate } from "./useTranslate";
import { login as loginApi } from "../api"; // Import login function from api.js

export const useLogin = () => {

  const t = useTranslate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Set default to false
  const { dispatch } = useAuthContext();

  // now expecting id and password
  const login = async (id, password) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await loginApi(id, password); // ✅ Call `login` from `api.js`
      // Axios automatically parses JSON, so we access response.data directly
      const json = response;

      if (response.error) {
        throw new Error(response.error);
      }

      // for debugging
      //console.log("json.user = ", json.user);

      // Ensure we save id, token, and username
      const userData = {
        id: id,
        token: json?.token,
        UserName: json?.username,
        roles: json?.user?.Roles,
      };

      // Save the user to local storage
      localStorage.setItem("user", JSON.stringify(userData));

      // Update the auth context
      dispatch({ type: "LOGIN", payload: userData });

      setIsLoading(false);
      setError(null);
      return true; // ✅ Success

    } catch (error) {
      setIsLoading(false);

      setError(error.message || t.loginFailed);
      localStorage.removeItem("user");
      return false;
    }
  };

  return { login, isLoading, error };
};